import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { CheckboxModule } from "primeng-v17/checkbox";
import { MultiSelectModule } from "primeng-v17/multiselect";
import { EscapeButtonDirective } from "../../../shared/directives/escape-button.directive";
import { FormElementMapModule } from "../../../shared/from-element-map/form-element-map.module";
import { AppendToBodyDirective } from "../../../shared/primeng/append-to-body/append-to-body.directive";
import { MultiSelectEditableColumnAutoFocusDirective } from "../../../shared/primeng/multi-select-editable-column-auto-focus/multi-select-editable-column-auto-focus.directive";
import { MultiSelectReadonlyFixDirective } from "../../../shared/primeng/multi-select-readonly-fix/multi-select-readonly-fix.directive";
import { MultiSelectSelectedItemsLabelDirective } from "../../../shared/primeng/multi-select-selectedItemsLabel/multi-select-selectedItemsLabel.directive";
import { MultiSelectSortSelectedValuesOnTopDirective } from "../../../shared/primeng/multi-select-sort-selected-values-on-top/multi-select-empty.directive";
import { TestIdDirective } from "../../../shared/test-id/test-id.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { ActivityTypeSelectorComponent } from "../../activity/activity-type-selector/activity-type-selector.component";
import { DocumentTypeSelectorComponent } from "../../activity/document-type-selector/document-type-selector.component";
import { NewUiNotificationConfigurationComponent } from "./new-ui-notification-configuration.component";

@Component({
  selector: "app-notification-configuration",
  templateUrl: "./notification-configuration.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    FormElementMapModule,
    TestIdDirective,
    NgIf,
    ActivityTypeSelectorComponent,
    MultiSelectModule,
    AppendToBodyDirective,
    MultiSelectEditableColumnAutoFocusDirective,
    MultiSelectReadonlyFixDirective,
    MultiSelectSelectedItemsLabelDirective,
    MultiSelectSortSelectedValuesOnTopDirective,
    DocumentTypeSelectorComponent,
    Button,
    EscapeButtonDirective,
  ],
})
export class NotificationConfigurationComponent extends NewUiNotificationConfigurationComponent {}
